const STORAGE_PREFIX = 'bambuser.lastPath';

const buildKey = (orgId, productId) => `${STORAGE_PREFIX}:${orgId}:${productId}`;

export const saveProductLastPath = (orgId, productId, path) => {
  if (!orgId || !productId || !path) return;
  try {
    localStorage.setItem(buildKey(orgId, productId), path);
  } catch {
    // localStorage may be unavailable (private mode, quota); non-fatal.
  }
};

export const clearAllProductLastPaths = () => {
  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(`${STORAGE_PREFIX}:`)) keysToRemove.push(key);
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch {
    // localStorage may be unavailable (private mode, quota); non-fatal.
  }
};

export const readProductLastPath = (orgId, productId) => {
  if (!orgId || !productId) return null;
  try {
    const stored = localStorage.getItem(buildKey(orgId, productId));
    if (!stored) return null;
    // Guard against stale/malformed entries from prior URL schemes or cross-org
    // leakage: the stored path must live under /{orgId}/{productId}.
    const expectedPrefix = `/${orgId}/${productId}`;
    if (stored !== expectedPrefix && !stored.startsWith(`${expectedPrefix}/`) && !stored.startsWith(`${expectedPrefix}?`)) {
      return null;
    }
    return stored;
  } catch {
    return null;
  }
};
